import { CoordsType, getDistanceBy2XY } from '../../utils/geometry';
import SpriteSheet, { SpriteSheetParams } from '../sprite/spriteSheet';
import Element, { ElementParams } from './element';

export interface AnimationParams extends ElementParams {
  reverse?: boolean;
  spriteParams?: SpriteSheetParams;
  sprite?: SpriteSheet;
  endCoords?: CoordsType;
  onEnd?: (self?: Animation) => void;
}

export default class Animation extends Element implements AnimationParams {
  reverse = false;
  spriteParams?: SpriteSheetParams;
  sprite!: SpriteSheet;
  endCoords?: CoordsType;
  onEnd?: (self?: Animation) => void;

  hasCollision = false;
  startCoords?: CoordsType;
  distByFrame?: number;

  constructor(params: AnimationParams) {
    super(params);
    this.applyParams(params);
    this.setSprite();

    if (this.endCoords) {
      this.startCoords = {
        x: this.x,
        y: this.y,
      };
      const framesNumber = this.sprite.frameCount * this.sprite.stageCount * this.sprite.numberOfFramesBeforeNextStep;
      const dist = getDistanceBy2XY({
        x1: this.startCoords.x,
        y1: this.startCoords.y,
        x2: this.endCoords.x,
        y2: this.endCoords.y,
      });
      this.distByFrame = dist / framesNumber;
    }
  }

  setSprite(): void {
    if (this.spriteParams) {
      this.sprite = new SpriteSheet({
        ...this.spriteParams,
        ...(this.reverse) ? { defaultFrameIndex: this.spriteParams.frameCount, defaultStageIndex: this.spriteParams.stageCount } : {}
      } as SpriteSheetParams);
      this.sprite.element = this;
    }
  }

  move(modifier: number): void {
    if (this.endCoords && this.distByFrame) {
      return this.moveByDistanceAndAngle(this.distByFrame, this.moveAngle);
    } else {
      super.move(modifier);
    }
  }

  update(modifier: number): Animation {
    this.move(modifier);

    if (this.sprite.ended) {
      if (this.onEnd) {
        this.onEnd(this);
      }
      this.remove();
      return this;
    }

    (!this.reverse)
      ? this.sprite.nextTick()
      : this.sprite.previousTick()
      ;
    return this;
  }
}
